import { Button, Drawer, Form, Space, Input } from "antd";
import moment from "moment";
import { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { BiExport } from "react-icons/bi";
import { RiFilterOffLine } from "react-icons/ri";
import DateLine from "../../../components/shared/DateLine";
import { ExportToExcel } from "../../../utils/XLSXExport";

const { Search } = Input;

export default function BookedPanel({
  isVisible,
  setShowDetails,
  vehicleBooked,
  startDate,
  endDate,
}: any) {
  const [search, setSearch] = useState("");
  const [form] = Form.useForm();

  const handleClearSearch = () => {
    setSearch("");
    form.resetFields();
  };
  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-lg">Vehicle Booked :</span>
          <DateLine startDate={startDate} endDate={endDate} />
        </div>
      }
      placement={"right"}
      width={800}
      onClose={() => setShowDetails(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setShowDetails(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="">
        <div className="flex justify-between items-center border-b border-gray-300 mb-2 pb-2 -mt-4 bg-white">
          <div className="flex">
            <Form layout="inline" form={form}>
              <Form.Item name="registration">
                <Search
                  placeholder="Search by registration"
                  allowClear
                  onChange={(val: any) => {
                    setSearch(val.target.value);
                  }}
                  onSearch={(value: any) => {
                    setSearch(value);
                  }}
                />
              </Form.Item>

              <Button className="" onClick={() => handleClearSearch()}>
                <RiFilterOffLine color="#6b7280" />
              </Button>
            </Form>
          </div>
          <div className="flex ">
            <button
              color="#E50000"
              className="flex justify-center items-center border p-1 hover:bg-green-100"
            >
              <BiExport size={24} />
              <span
                className="ml-2"
                onClick={() =>
                  ExportToExcel(
                    vehicleBooked?.map((record: any, index: number) => {
                      return {
                        "S/N": index + 1,
                        Registration:
                          record?.registration === null
                            ? "-"
                            : record?.registration,
                        "Date Due In":
                          record?.date_due_in === null
                            ? "-"
                            : moment(record?.date_due_in.toString()).format(
                                "Do MMM YYYY"
                              ),
                        Customer:
                          record?.customer === null ? "-" : record?.customer,
                        Model: record?.model === null ? "-" : record?.model,
                        WIP: record?.wip === null ? "-" : record?.wip,
                      };
                    }),
                    "Booked.xlsx"
                  )
                }
              >
                Export To Excel
              </span>
            </button>
          </div>
        </div>
        <div className="flex py-1 border-b border-gray-300">
          <div className="mr-2 w-10 text-center font-bold">S/N.</div>
          <div className="flex justify-between items-center flex-1">
            <div className="flex items-center">
              <div className="w-24 font-bold mr-2">Vehicle</div>
              <div className="w-24 font-bold mr-4">Date due in</div>
              <div className="w-56 truncate font-bold">Customer</div>
            </div>
            <div className="font-bold text-center">WIP</div>
          </div>
        </div>
        {vehicleBooked
          ?.filter((vehicle: any) => vehicle?.registration?.includes(search))
          .map((item: any, index: number) => (
            <div className="flex py-1 border-b border-gray-300" key={index}>
              <div className="mr-2 w-10 text-center">{index + 1}.</div>
              <div className="flex justify-between items-center flex-1">
                <div className="flex items-center">
                  <div className="w-24 mr-2 truncate">{item?.registration}</div>
                  <div className="w-24 truncate text-left mr-4">
                    {item?.date_due_in === null ? (
                      "-"
                    ) : (
                      <span>
                        {moment(item?.date_due_in.toString()).format(
                          "Do MMM YYYY"
                        )}
                      </span>
                    )}
                  </div>
                  <div className="w-56 truncate">
                    {item.customer === " " ? "-" : item.customer}
                  </div>
                </div>
                <div className="">{item?.wip}</div>
              </div>
            </div>
          ))}
        <div className="flex justify-between items-start border-t-2 border-b-2 py-2">
          <div className="font-bold">Total Vehicles</div>
          <div className="font-bold">
            {
              vehicleBooked?.filter((vehicle: any) =>
                vehicle?.registration?.includes(search)
              ).length
            }
          </div>
        </div>
      </div>
    </Drawer>
  );
}
